import React, { useEffect, useState } from 'react'

import './styles.scss'
import ModalWrapper from 'components/ModalWrapper'
import { SelectWithLabel } from 'components/Form'
import { lang } from 'utils/helpers'

const HashtagsManager = ({ isOpen, toggle, hashtags, currentHashtags, onSave, refresh }) => {
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [selectedHashtags, setSelectedHashtags] = useState(currentHashtags || [])
  const [savedHashtags, setSavedHashtags] = useState(currentHashtags || [])

  useEffect(() => {
    setSelectedHashtags(currentHashtags || [])
    setSavedHashtags(currentHashtags || [])
  }, [refresh])

  const toggleModal = (type) => {
    const isOpenValue = isOpen !== undefined ? isOpen : isOpenModal
    if (isOpenValue && type !== 'saved') setSelectedHashtags(savedHashtags || [])
    if (typeof toggle === 'function') {
      toggle()
    } else {
      setIsOpenModal(!isOpenValue)
    }
  }

  const handleSave = () => {
    if (typeof onSave === 'function') onSave(selectedHashtags)
    setSavedHashtags(selectedHashtags)
    toggleModal('saved')
  }

  return (
    <>
      {typeof toggle === 'function' && !savedHashtags?.length ? (
        null
      ) : (
        <div className='hashtags-manager'>
          {savedHashtags?.length ? (
            <div className='hashtags-manager__hashtags-container'>
              {savedHashtags.map((selectedHashtag, index) => index < 3 && (
                <button
                  key={index}
                  title={`#${selectedHashtag.label}`}
                  className='hashtags-manager__hashtag text-ellipsis'
                  onClick={toggleModal}
                >
                  #{selectedHashtag.label}
                </button>
              ))}
              {savedHashtags.length > 3 ? (
                <button
                  className='hashtags-manager__hashtag hashtags-manager__hashtag--more'
                  onClick={toggleModal}
                >
                  {lang('dashboard_more-count', { count: savedHashtags.length - 3 })}
                </button>
              ) : null}
            </div>
          ) : (
            typeof toggle !== 'function'
              ? (
                <button className='hashtags-manager__hashtag' onClick={toggleModal}>#</button>
              ) : null
          )}
        </div>
      )}
      <ModalWrapper
        isOpen={isOpen !== undefined ? isOpen : isOpenModal}
        toggle={toggleModal}
        header={lang('message-labels')}
        legend={lang('dashboard_add-message-labels')}
        body={
          <SelectWithLabel
            multi
            grouped={false}
            placeholder={lang('dashboard_select-labels')}
            options={hashtags || []}
            value={selectedHashtags}
            onChange={setSelectedHashtags}
          />
        }
        eventBtnTxt={lang('dashboard_save')}
        eventBtn={handleSave}
        cancelBtnTxt={lang('dashboard_cancel')}
        cancelBtn={toggleModal}
      />
    </>
  )
}

export default HashtagsManager
